@for (menu of parentMenu; track menu.id) {
<div class="menu-item">
    @if (menu.routerLink && !menu.hasSubMenu && !menu.newTab) {
    <a [style.flex-direction]="settings.menuType === 'default' ? 'row' : 'column'"
        [style.justify-content]="settings.menuType === 'default' ? 'flex-start' : 'center'"
        style="display:flex; align-items:center; width:100%; position:relative;"
        [routerLink]="[menu.routerLink]" routerLinkActive="active-link" [routerLinkActiveOptions]="{exact:true}"
        [title]="menu.title" [id]="'menu-item-'+menu.id">
        @if (menu.icon) {
        <span class="menu-icon svg-icon" [innerHTML]="getSvgIcon(menu.icon)"></span>
        }
        <span class="menu-title">{{menu.title}}</span>
    </a>
    }
    @if (menu.href && !menu.hasSubMenu && menu.newTab) {
    <a [style.flex-direction]="settings.menuType === 'default' ? 'row' : 'column'"
        [style.justify-content]="settings.menuType === 'default' ? 'flex-start' : 'center'"
        style="display:flex; align-items:center; width:100%; position:relative;"
        [attr.href]="menu.href || ''" target="_blank"
        [title]="menu.title" (click)="onClick(menu.id)" [id]="'menu-item-'+menu.id">
        @if (menu.icon) {
        <span class="menu-icon svg-icon" [innerHTML]="getSvgIcon(menu.icon)"></span>
        }
        <span class="menu-title">{{menu.title}}</span>
    </a>
    }
    @if (menu.hasSubMenu) {
    <a [style.flex-direction]="settings.menuType === 'default' ? 'row' : 'column'"
        [style.justify-content]="settings.menuType === 'default' ? 'flex-start' : 'center'"
        style="display:flex; align-items:center; width:100%; position:relative;"
        role="button" tabindex="0"
        [title]="menu.title" (click)="onClick(menu.id)"
        (keydown.enter)="onClick(menu.id)" (keydown.space)="onClick(menu.id)"
        [id]="'menu-item-'+menu.id">
        @if (menu.icon) {
        <span class="menu-icon svg-icon" [innerHTML]="getSvgIcon(menu.icon)"></span>
        }
        <span class="menu-title">{{menu.title}}</span>
        <span class="menu-expand-icon">▼</span>
    </a>

    <div class="sub-menu" [id]="'sub-menu-'+menu.id" (click)="logmenu($event)">
        <app-vertical-menu [menuItems]="menuItems" [menuParentId]="menu.id"></app-vertical-menu>
    </div>
    }
</div>
}
